export default __webpack_public_path__ + "static/media/logo-md-1024w.7eaae49e.webp";